export const PAGES = {
  PATIENTS: '/dashboard/patients',
  DASHBOARD: '/dashboard/overview',
  FILES: '/dashboard/files/home',
  LAB_DASHBOARD: '/dashboard/lab/overview',
  LAB_ORDERS: '/dashboard/lab/orders',
  LAB_TASKS: '/dashboard/lab/tasks',
  LAB_CUSTOMERS: '/dashboard/lab/customers',
  ORDERS: '/dashboard/orders',
  CASES: '/dashboard/cases',
  SCAN_SERVICES: '/dashboard/scan-services',
  TASKS: '/dashboard/tasks',
} as const;
